module.exports = "/static/assets/bbbd98ae6a34eac772e34a57aaa5f977.svg";